export const styles = {
  wrapper: {
    width: '100%',
    height: '50px',
  },

  itemsContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
  },

  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '8px',
    padding: '8px 12px',
    backgroundColor: '#f3f4f9',
    borderRadius: '12px',
  },

  typo: {
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '146%',
    fontWeight: '400',
  },
};
